<div class="d-flex">
  <!-- Form -->
  <form (ngSubmit)="this.form.submit()" [formGroup]="this.form" class=" flex-grow-1">

    @if (debugUtils.isDebug()) {
      <div class="row mt-3">
        <div class="col-12">
          <magieno-select
                  [advancedFormControl]="this.form.formElements.algorithm | asAdvancedFormControl"></magieno-select>
        </div>
      </div>
    }

    <div class="row">
      <div class="col-12">
        <h1 id="salary-dividend-parameters">Paramètres du calcul salaire-dividende </h1>
        <div class="card">
          <div class="card-body">
            <div class="d-flex gap-3">
              <magieno-select
                      [advancedFormControl]="this.form.formElements.year | asAdvancedFormControl"></magieno-select>


              <magieno-input-money-field
                      [advancedFormControl]="this.form.formElements.costOfLiving | asAdvancedFormControl"
                      [currency]="this.currency"
                      [locale]="this.locale"></magieno-input-money-field>
            </div>


            <div class="d-flex gap-3">
              <magieno-boolean-select
                      class="flex-fill"
                      [advancedFormControl]="this.form.formElements.isEligibleDividendMaximized | asAdvancedFormControl"></magieno-boolean-select>

              <magieno-boolean-select
                      class="flex-fill"
                      [advancedFormControl]="corporateFederalTaxForm.formElements.isPartIVTaxUsed | asAdvancedFormControl"></magieno-boolean-select>

              <magieno-boolean-select
                      class="flex-fill"
                      [advancedFormControl]="this.form.formElements.isQppPensionCalculated | asAdvancedFormControl"></magieno-boolean-select>

            </div>

          </div>
        </div>



      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <app-salary-dividend-personal-tax-form [form]="form"
        [incomeTaxPersonalForm]="personalIncomeForm"></app-salary-dividend-personal-tax-form>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <app-salary-dividend-corporate-tax-form [corporateIncomeTaxOptionsForm]="corporateTaxForm"
        [form]="form"></app-salary-dividend-corporate-tax-form>
      </div>
    </div>

    @if (this.form.value.isQppPensionCalculated === true) {
      <div class="row mt-3">
        <div class="col-12">
          <app-salary-dividend-qpp-pension-form [form]="form"
          [qppPensionForm]="qppPensionForm"></app-salary-dividend-qpp-pension-form>
        </div>
      </div>
    }

    <br>
      <br>
        <br>
          <br>


            <!-- Button -->
            <div class="row fixed-bottom">
              <div class="col-12">
                <magieno-button [button]="this.form.getButton('SAVE')" id="saveCalculationButton"></magieno-button>

                <magieno-button [button]="this.form.getButton('EXECUTE')" id="executeCalculationButton"
                                style="margin-left: 12px"></magieno-button>

                <span [class.bg-danger]="calculationStatusEnum === 'ERROR'"
                  [class.bg-light]="calculationStatusEnum === 'CREATED'"
                  [class.bg-success]="calculationStatusEnum === 'COMPLETED'"
                  [class.bg-warning]="calculationStatusEnum === 'IN_PROGRESS'"
                  class="badge rounded-pill ms-5"
                  style="font-size: 12pt;"

                >{{ getStatusText() }}</span>

                <button (click)="openErrorsSidebar()" [class.bg-danger]="this.numberOfErrors > 0"
                  [class.bg-success]="this.numberOfErrors === 0"
                  class="btn badge text-white rounded-pill ms-3"
                  style="font-size: 12pt;">{{ this.numberOfErrors }}
                  erreurs
                </button>

                <span style="margin-left: 15px;">Dernière sauvegarde: <strong>{{ getLastModifiedText() }}</strong></span>

              </div>
            </div>


          </form>

          <app-calculation-form-sidebar></app-calculation-form-sidebar>

        </div>
